<template>
<div
  class="form-group"
>
  <label>Local que ocorrerá o evento</label>

  <gmap-autocomplete
    ref="inputAutocomplete"
    class="form-control form-control-alternative"
    style="width: 100%"
    placeholder
    :value="place"
    @place_changed="setPlace"
    required
  ></gmap-autocomplete>
  <GmapMap
    ref="mapRef"
    :center="marker"
    :zoom="defaultZoom"
    :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false,
                gestureHandling: 'cooperative'
              }"
    style="width: 100%; height: 600px; margin-top: 10px"
  >
    <Gmap-Marker
      :position="gps || marker"
      :draggable="true"
      @dragend="setMarkerByClick"
    ></Gmap-Marker>
  </GmapMap>
  <small>Você pode clicar no mapa para marcar o local desejado.</small>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {gmapApi} from 'vue2-google-maps'

export default {
  name: 'EventLocalMap',

  props: {
    specGps: {
      required: false
    }
  },

  watch: {
    specGps () {
      if (this.specGps) {
        this.gps = {
          lat: this.specGps.lat,
          lng: this.specGps.lng
        }
        this.marker = this.gps
      } else {
        this.getLocationState()
      }
    }
  },

  data () {
    return {
      show: false,
      defaultZoom: 10,
      mapPlace: null,
      marker: {
        lat: 0,
        lng: 0
      },
      place: '',
      city: '',
      neighborhood: '',
      gps: {
        lat: 0,
        lng: 0
      }
    }
  },

  computed: {
    ...mapGetters('project', ['project'])
  },

  methods: {
    ...mapActions('project', {fetchProject: 'fetchOne'}),
    myGoogle () {
      return gmapApi()
    },
    center () {
      if (this.myGoogle) {
        this.getLocationState()
        return this.marker
      }
      return {
        lat: 1,
        lng: 1
      }
    },
    getLocationState () {
      if (typeof window.google === 'undefined') {
        return this.waitToCall()
      }
      const geocoder = new window.google.maps.Geocoder()
      return geocoder.geocode({'address': `${this.project.state}, Brasil`}, (result, status) => {
        if (status === 'OK') {
          this.marker = {
            lat: result[0].geometry.location.lat(),
            lng: result[0].geometry.location.lng()
          }
          this.gps = this.marker
        }
      }, (err) => console.log('err, geocode', err))
    },

    setPlace (place) {
      console.log('place')
      this.place = place.formatted_address
      this.defineAddressComponents()
      this.marker.lat = place.geometry.location.lat()
      this.marker.lng = place.geometry.location.lng()
      this.gps = this.marker
      this.defaultZoom = 10
      this.$emit('changeGps', this.gps)
    },

    async setMarkerByClick (marker) {
      console.log('setmarkerbyclick')
      if (typeof window.google === 'undefined') {
        return this.waitToCall()
      }
      const geocoder = new window.google.maps.Geocoder()
      const location = marker.latLng

      await geocoder.geocode({location}, (result, status) => {
        if (status === 'OK') {
          this.marker.lat = result[0].geometry.location.lat()
          this.marker.lng = result[0].geometry.location.lng()
          this.gps = this.marker
          this.$emit('changeGps', this.gps)
          this.place = result[0].formatted_address
        }
      }, (err) => console.log(err))
    },

    defineAddressComponents () {
      if (!this.place.hasOwnProperty('address_components')) {
        return
      }
      this.neighborhood = '-'
      this.city = '-'
      for (let placeI in this.place.address_components) {
        if (
          this.place.address_components[placeI].types[0] === 'sublocality_level_1'
        ) {
          this.neighborhood = this.place.address_components[placeI].long_name
        }
        if (
          this.place.address_components[placeI].types[0] ===
          'administrative_area_level_2'
        ) {
          this.city = this.place.address_components[placeI].long_name
        }
      }

      // this.lat_gps = this.place.geometry.location.lat()
      // this.lng_gps = this.place.geometry.location.lng()
    },
    waitToCall () {
      setTimeout(() => {
        this.getLocationState()
      }, 1000)
    }
  },
  mounted () {
    this.fetchProject('config')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/EventsSpecifications/EventLocalMap.vue